import React from 'react';
import { Helmet } from 'react-helmet-async';

const expertsData = [
    { id: 1, name: 'Игорь Манн', country: 'Россия', description: 'один из самых известных российских маркетологов, автор бестселлеров по маркетингу и брендингу.' },

    { id: 2, name: 'Анвар Агаев', country: 'Азербайджан', description: 'известный специалист по цифровому маркетингу, основатель и генеральный директор маркетингового агентства.' },
    { id: 3, name: 'Армен Саркисян', country: 'Армения', description: 'основатель маркетингового агентства, известен своими креативными кампаниями и стратегиями для брендов.' },
    { id: 4, name: 'Максим Попов', country: 'Беларусь', description: 'маркетолог с сильным портфолио в области цифрового маркетинга и рекламы.' },
    { id: 5, name: 'Данияр Алимбаев', country: 'Казахстан', description: 'специалист по маркетинговым стратегиям и брендингу, руководитель маркетингового агентства.' },
    { id: 6, name: 'Азиза Юсупова', country: 'Киргизия', description: 'эксперт в области цифрового маркетинга, внесла значительный вклад в развитие маркетинговой индустрии своей страны.' },

    { id: 7, name: 'Зарина Рахимова', country: 'Таджикистан', description: 'маркетолог с опытом работы в крупных проектах, включая запуск брендов и продвижение продуктов на местном рынке.' },
    { id: 8, name: 'Айгуль Какабаева', country: 'Туркменистан', description: 'маркетолог и консультант по брендингу, известная своими успешными кампаниями для местных предприятий.' },
    { id: 9, name: 'Шахзода Махмудова', country: 'Узбекистан', description: 'специалист по цифровому маркетингу, который проводит обучение и консультации для растущих компаний в Узбекистане.' },
    { id: 10, name: 'Нино Карумидзе', country: 'Грузия', description: 'известный маркетолог, который сделал значительный вклад в развитие цифрового маркетинга в Грузии. Она основала успешное маркетинговое агентство, которое специализируется на интегрированных маркетинговых стратегиях, включая социальные медиа, контент-маркетинг и бренд-менеджмент. Нино также активно участвует в образовательных программах, проводя семинары и мастер-классы для молодых специалистов в области маркетинга.' },
  ];

function MembersBA() {
  return (
    <div className="xContent p-box py-6">
      <Helmet>
        <title>Члены правления</title>
        <meta
        name="description"
        content="Члены правления Международной Ассоциации маркетологов СНГ"
        />
        <link rel="canonical" href="https://marketing-association.com/membersBA" />
      </Helmet>
      {/* <h1 className="title">Критерии отбора кандидатов в Члены Правления Международной Ассоциации Маркетологов СНГ.</h1>
      <p className='has-text-left p-style'>1. Профессиональный уровень и управленческий опыт</p>
      <ul class="criteriaList">
        <li><b>Титул и позиция:</b> <br /> – Должность не ниже CMO, VP по маркетингу, Executive Director по маркетингу или эквивалент в международной либо ведущей национальной компании.</li>
        <li><b>Стаж:</b> <br /> – Не менее 5 лет безупречной карьеры в области стратегического маркетинга, бренд-менеджмента или digital-маркетинга.</li>
        <li><b>Объёмы под управлением:</b> <br /> – Руководство подразделением или проектами с годовым бюджетом свыше $3 млн и/или коллективом не менее 15 специалистов.</li>
      </ul>
      <p className='has-text-left p-style'>2. Национальное и международное признание</p>
            <ul class="criteriaList">
        <li><b>Премии и награды:</b> <br /> – Лауреат как минимум одной крупной международной награды (Effie Awards, Cannes Lions, Global CMO Excellence Awards и т. д.) или национальной премии уровня «Лучший маркетинг-проект года».</li>
        <li><b>Публикации:</b> <br /> – Автор статей в рецензируемых международных журналах (Journal of Marketing Research, Marketing Science) или ведущих отраслевых изданиях (Adweek, Marketing, «Маркетинг и маркетинговые исследования»).</li>
      </ul>
      <p className='has-text-left p-style'>3. Выступления и судейство</p>
      <ul class="criteriaList">
        <li><b>Спикерская деятельность:</b> <br /> – Официальный докладчик на не менее чем трёх международных конференциях (Cannes Lions, DMEXCO, Web Summit, Adtech) за последние пять лет.</li>
        <li><b>Членство в жюри конкурсов:</b> <br /> – Опыт судейства на международных маркетинговых и рекламных конкурсах (Effie, Webby Awards, International Content Marketing Awards) не менее трёх раз, подтверждённый упоминаниями на официальных сайтах событий.</li>
      </ul>
      <p className='has-text-left p-style'>4. Академические и экспертные заслуги</p>
            <ul class="criteriaList mb-40" >
        <li><b>Образование:</b> <br /> – Степень магистра или PhD в маркетинге, бизнес-администрировании, коммуникациях или смежных дисциплинах в признанных международных вузах (INSEAD, London Business School, HEC Paris и др.).</li>
        <li><b>Преподавание и менторство:</b> <br /> – Приглашённый лектор в бизнес-школах и университетах, автор и ведущий специализированных курсов по маркетингу (не менее двух курсов за последние три года).</li>
        <li><b>Консультационные проекты:</b> <br /> – Участие в качестве старшего консультанта в международных консалтинговых проектах с минимальной стоимостью контракта $500 000.</li>
      </ul> */}
      <h1 className="title">Члены правления Международной Ассоциации маркетологов СНГ:</h1>
      <div className="expertsTable">
      <table>
        <thead>
          <tr>
            <th>№</th>
            <th>ФИО</th>
            <th>Страна</th>
            <th>Достижения</th>
          </tr>
        </thead>
        <tbody>
          {expertsData.map(expert => (
            <tr key={expert.id}>
              <td>{expert.id}</td>
              <td>{expert.name}</td>
              <td>{expert.country}</td>
              <td>{expert.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}

export default MembersBA;
